
import React from 'react';
import { Box, Table, TableBody, TableCell, TableHeader, TableRow, Text } from 'grommet';

import SectionTitle from './common/SectionTitle';
import ImagesPreviewPanel from './common/ImagesPreviewPanel';
import { getDendrogramInfo } from '../text';

function getImages(odrudaSsr) {
    return [{
        id: odrudaSsr.id,
        type: 'preview',
        fileName: `${odrudaSsr.data.attributes.dendrogram}.jpg`,
        title: 'Dendrogram'
    }];
}

const SectionDendrogram = ({odrudaSsr}) => {
    return (odrudaSsr.data.attributes.dendrogram)
        ? (
            <Box>
                <SectionTitle title="Dendrogram" infoLink={{text: '(co je dendrogram)', link: '#/link_dendrogram'}} />
                <ImagesPreviewPanel images={getImages(odrudaSsr)} />
                <Text>{getDendrogramInfo(odrudaSsr.data.attributes.dendrogram)}</Text>
            </Box>
        )
        : null;
}

const SectionOverview = ({odrudaSsr}) => {
    return (
        <SectionTitle title={odrudaSsr.data.attributes.nazev} />
    );
}

const SsrTable = ({data}) => {
    let odrudaZkratka = data.attributes.zkratka;
    const COLS_HEADER = ['VVS 2', 'VVMD 5', 'VVMD 7', 'VVMD25', 'VVMD 27', 'VVMD 28', 'VVMD 32', 'VrZAG 62', 'VrZAG 79'];
    const SSR_VALUE_COUNT = (odrudaZkratka === 'ML') ? 19 : 18;
    const COLS_VALUE = Array.from(Array(SSR_VALUE_COUNT), (x, index) => index + 1);
    return (
        <Table style={{width: 1000}}>
            <SsrTableHeader odrudaZkratka={odrudaZkratka} colsHeader={COLS_HEADER} />
            <TableBody>
                {data.ssrData.map(row => {
                    let numRows = (hasSsrRowValues(row, 2, COLS_VALUE)) ? 2 : 1;

                    return [1,2].map(item => {
                        return (
                            <SsrTableRows
                                key={item}
                                row={row}
                                numRows={numRows}
                                item={item}
                                colsValue={COLS_VALUE}
                            />
                        );
                    })
                })}
            </TableBody>
        </Table>
    )
}

function hasSsrRowValues(row, item, colsValue) {
    return colsValue.reduce((previous, current) => {
        return (previous || (row[`v_${item}_${current}`] !== null));
    }, false);
}

const SsrTableRows = ({row, numRows, item, colsValue}) => {
    let hasValues = hasSsrRowValues(row, item, colsValue);

    if (hasValues) {
        return <SsrTableRow row={row} numRows={numRows} item={item} colsValue={colsValue} />
    } else {
        return null;
    }
}

const SsrTableHeader = ({odrudaZkratka, colsHeader}) => {
    return (
        <TableHeader>
            <TableRow>
                <TableCell plain={true}>
                    <Box border="all" height="26px"></Box>
                </TableCell>
                {colsHeader.map((item, index) => {
                    // Note:
                    // - odruda 'ML' ma ve VVS 3 vyjimecne 3 hodnoty (v ostatnich pripadech jsou 2)
                    let colSpan = ((odrudaZkratka === 'ML') && (index === 0)) ? 3 : 2;
                    return (
                        <TableCell key={index} colSpan={colSpan} plain={true} border="bottom">
                            <Box border="all">
                                <Text textAlign="center" weight="bold">{item}</Text>
                            </Box>
                        </TableCell>
                    );
                })}
            </TableRow>
        </TableHeader>
    );
}

const SsrTableRow = ({row, numRows, item, colsValue}) => {
    const background = (row.typ === 'main') ? 'brand' : '';
    const height = (numRows === 2) ? '52px' : '26px';
    return (
        <TableRow key={item}>
            {(item === 1)
                ? (
                    <TableCell plain={true} rowSpan={numRows}>
                        <Box border="all" height={height} background={background}>
                            <Text textAlign="start">{row['nazev']}</Text>
                        </Box>
                    </TableCell>
                )
                : null
            }
            {colsValue.map(col => {
                return (
                    <TableCell plain={true} key={col}>
                        <Box border="all" background={background}>
                            <Text style={{marginTop: 4}} size="small" textAlign="center">{row[`v_${item}_${col}`] || '-'}</Text>
                        </Box>
                    </TableCell>
                );
            })}
        </TableRow>
    );
}

const SectionSsrTable = ({odrudaSsr}) => {
    return (
        <Box>
            <SectionTitle title="Výsledky analýzy SSR" />
            <SsrTable data={odrudaSsr.data} />
            <Box pad={{top: '32px'}}>
                <Text>{odrudaSsr.data.attributes.ssr_komentar}</Text>
            </Box>
        </Box>
    );
}

const OdrudaSsr = ({odrudaSsr}) => {
    return (
        <Box gap="medium">
            <SectionOverview odrudaSsr={odrudaSsr} />
            <SectionSsrTable odrudaSsr={odrudaSsr} />
            <SectionDendrogram odrudaSsr={odrudaSsr} />
        </Box>
    );
}

export default OdrudaSsr;
